import isUndefined from 'lodash/isUndefined';
import find from 'lodash/find';

export const errorModule = {
    namespaced: true,
    state: {
        errors: [],
    },
    getters: {
        // ERRORS
        errors: (state) => state.errors,
        errorByKey: (state, getters) => (key) => {
            const error = find(getters.errors, ({key}));
            return isUndefined(error) ? null : error;
        },
    },
    actions: {
        // ERRORS
        clearErrors: ({commit}) => commit('clearErrors'),
        setError: ({commit}, data) => commit('setError', data),
    },
    mutations: {
        // ERRORS
        clearErrors: (state) => state.errors.splice(0, state.errors.length),
        setError: (state, data) => state.errors.push(data),
    }
}



// WEBPACK FOOTER //
// ./src/components/error/store.js